/**
 * Разбор списка доменов, вставленного в текстовое поле или загруженного
 * файлом (FR-1.1).
 *
 * Разделители: перевод строки, запятая, точка с запятой, пробел/таб.
 * Пустые строки отбрасываются. Нормализация значений — на сервере
 * (App\Support\DomainNormalizer): здесь только грубый разбор, чтобы
 * показать предпросмотр и не гонять мегабайты по сети.
 */

/** Разделители: \r\n, \n, ',', ';' и любые пробельные */
const SEPARATORS = /[\s,;]+/;

/** Верхняя граница импорта за сессию (FR-1.4) */
export const MAX_IMPORT_DOMAINS = 100000;

/** Размер чанка одного HTTP-запроса (FR-1.4) */
export const IMPORT_CHUNK_SIZE = 5000;

export function parseDomainList(raw: string): string[] {
    if (!raw) {
        return [];
    }

    return raw
        .split(SEPARATORS)
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
}

/**
 * Количество повторов внутри списка (после приведения к нижнему регистру —
 * сервер нормализует так же).
 */
export function countDuplicatesInInput(domains: string[]): number {
    const seen = new Set<string>();
    let duplicates = 0;

    for (const domain of domains) {
        const key = domain.toLowerCase();
        if (seen.has(key)) {
            duplicates++;
            continue;
        }
        seen.add(key);
    }

    return duplicates;
}

/** Уникальные значения (первое вхождение сохраняется). */
export function uniqueDomains(domains: string[]): string[] {
    const seen = new Set<string>();
    const result: string[] = [];

    for (const domain of domains) {
        const key = domain.toLowerCase();
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        result.push(domain);
    }

    return result;
}

/** Нарезать список на чанки по размеру запроса. */
export function chunkDomains(domains: string[], size: number = IMPORT_CHUNK_SIZE): string[][] {
    if (size <= 0) {
        return [domains];
    }

    const chunks: string[][] = [];

    for (let i = 0; i < domains.length; i += size) {
        chunks.push(domains.slice(i, i + size));
    }

    return chunks;
}
